import { render, staticRenderFns } from "./MdtEditButton.vue?vue&type=template&id=6efb522e&scoped=true"
import script from "./MdtEditButton.vue?vue&type=script&lang=js"
export * from "./MdtEditButton.vue?vue&type=script&lang=js"
import style0 from "./MdtEditButton.vue?vue&type=style&index=0&id=6efb522e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6efb522e",
  null
  
)

export default component.exports